var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.74,29.47H19.28V3.77H36.71v25.7h-8L27.53,26l-2.11-.23A23.93,23.93,0,0,0,22.83,27C22.68,27.23,21.74,29.47,21.74,29.47Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "28 29.47 36.71 29.47 36.71 3.77 19.28 3.77 19.28 25.77 19.28 29.47 21.74 29.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.05,23.2l-4,2.53a3.81,3.81,0,0,0-1.77,3.21v8.24a3.62,3.62,0,0,0,1.56,3h0a3.62,3.62,0,0,1,1.56,3v4.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,47.23V43.06a3.64,3.64,0,0,1,1.61-3h0a3.61,3.61,0,0,0,1.61-3v-8a3.29,3.29,0,0,0-3.29-3.3h0a3.3,3.3,0,0,0-3.3,3.3v4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCard);
export default __webpack_public_path__ + "static/media/RED_CARD.a000771466ea504c7ecac83f814dcc6a.svg";
export { ForwardRef as ReactComponent };